import { DebugEvent } from 'core/DebugEvent';

interface CustomCursorEventInterface {
	type: string;
	active: boolean;
	id: string;
	theme?: string;
}

export class CustomCursorEvent extends DebugEvent implements CustomCursorEventInterface {
	public static eventName: string = 'CUSTOM_CURSOR_EVENT';
	public type: string;
	public active: boolean;
	public id: string;
	public theme: string;

	constructor(parameters: CustomCursorEventInterface) {
		super(parameters);
	}
}
